import {
  InstructionsEditorMentionItem,
  InstructionsEditorState,
  InstructionsEditorAction,
} from "./instructions-editor.types";

export function instructionsEditorReducer<T extends InstructionsEditorMentionItem>(
  state: InstructionsEditorState<T>,
  action: InstructionsEditorAction<T>
): InstructionsEditorState<T> {
  switch (action.type) {
    case "CLIENT_RECT_CHANGED":
      return {
        ...state,
        clientRect: action.payload,
      };

    case "QUERY_CHANGED":
      return {
        ...state,
        query: action.payload,
      };

    case "SEARCH_COMPLETED":
      return {
        ...state,
        data: action.payload,
        hasSearched: true,
        isLoading: false,
        isOpen: true,
        keyboardSelectionIndex: action.payload.length > 0 ? 0 : -1,
      };

    case "SEARCH_FAILED":
      return {
        ...state,
        hasSearched: true,
        isLoading: false,
      };

    case "LOADING_STARTED":
      return {
        ...state,
        isLoading: true,
        isOpen: true,
      };

    case "LOADING_STOPPED":
      return {
        ...state,
        isLoading: false,
      };

    case "POPOVER_OPENED":
      return {
        ...state,
        isOpen: true,
      };

    case "POPOVER_CLOSED":
      return {
        ...state,
        isOpen: false,
      };

    case "EMPTY_STATE_CHANGED":
      return {
        ...state,
        isEmpty: action.payload,
      };

    case "KEYBOARD_SELECTION_CHANGED":
      return {
        ...state,
        keyboardSelectionIndex: action.payload,
      };

    case "RESET":
      return {
        ...state,
        isOpen: false,
        isLoading: false,
        hasSearched: false,
        clientRect: undefined,
        data: [] as T[],
        query: "",
        keyboardSelectionIndex: -1,
      };

    default:
      return state;
  }
}
